export function mapUser(u: any) {
  const iFirstname = u.firstName ? u.firstName[0].toUpperCase() : ''
  const iLastname = u.lastName ? u.lastName[0].toUpperCase() : ''
  return {
    id: u.id,
    firstname: u.firstName,
    lastname: u.lastName,
    initials: iFirstname + iLastname,
    mobile: u.mobile,
    email: u.email,
    active: u.active,
    groups: u.groups,
    accountIds: u.accountIds?.map((i: number) => String(i)) || [],
    adminAccountIds: u.adminAccountIds?.map((i: number) => String(i)) || [],
    customerLocationIds: u.customerLocationIds?.map((i: number) => String(i)) || [],
    viewAllLocationsAccountIds:
      u.viewAllLocationsAccountIds?.map((i: number) => String(i)) || [],
    adminCustomerLocationIds: u.adminCustomerLocationIds?.map((i: number) => String(i)) || [],
    alertLocationIds: u.alertLocationIds?.map((i: number) => String(i)) || [],
    customerLocations:
      u.customerLocation?.map(
        (l: { customerLocationIdRef: number; admin: boolean; emergencyContact: boolean }) => {
          return {
            locationId: String(l.customerLocationIdRef),
            admin: l.admin,
            emergencyContact: l.emergencyContact,
          }
        },
      ) || [],
    accounts:
      u.accounts?.map(
        (a: {
          id: number
          admin: boolean
          autoAddLocations: boolean
          autoAddAlerts: boolean
          invoice: boolean
          accountContact: boolean
          position?: string
        }) => ({
          // `id` is the account id, not the association-row id: the API builds each
          // row with `id=acc.account_id_ref`. Do not "correct" this to accountIdRef.
          accountId: String(a.id),
          admin: a.admin,
          autoAddLocations: a.autoAddLocations,
          autoAddAlerts: a.autoAddAlerts,
          invoice: a.invoice,
          accountContact: a.accountContact,
          position: a.position,
        }),
      ) || [],
    preferences: u.preferences ?? null,
    accountContactIds: u.accountContactIds?.map((i: number) => String(i)) || [],
  }
}
